import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';

import { useAuthContext } from '@/context/AuthContext.tsx';

const OnboardingLogoutButton: FC = () => {
  const { t } = useTranslation();
  const { logout } = useAuthContext();

  return (
    <button
      type="button"
      onClick={logout}
      aria-label={t('button.logout')}
      className="fixed right-5 top-5 z-[60] flex items-center gap-2 rounded-md px-3 py-2 font-sans text-base font-medium text-error transition-[color,opacity] duration-300 hover:opacity-75 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-error sm:right-8 sm:top-7"
    >
      <ArrowRightOnRectangleIcon
        className="h-6 w-6"
        aria-hidden="true"
      />

      <span>{t('button.logout')}</span>
    </button>
  );
};

export default OnboardingLogoutButton;